// Components==============
import Modal from 'components/UI/Modal';
import React from 'react';
import './ExtraInformationModal.module.scss';
import RichText from 'components/UI/RichText';
import popupData from '../../../../PopupData.js';
// =========================

export default function ExtraInformationModal(props) {
    const url = window.location.href;
    const lastSlashIndex = url.lastIndexOf('/');
    const urlParam = url.substring(lastSlashIndex + 1);

    return (
        <Modal color={props?.color} slug="extra-informatie-popup">
            <div styleName="content">
                <RichText richText={popupData[urlParam]} />
            </div>
        </Modal>
    );
}
